'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeasuring$002dUnit from "./mealorama.-Measuring-Unit.js";
var $p;
/** @constructor */
function $c_Lmealorama_MeasuringUnit$() {
}
export { $c_Lmealorama_MeasuringUnit$ as $c_Lmealorama_MeasuringUnit$ };
$p = $c_Lmealorama_MeasuringUnit$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MeasuringUnit$;
/** @constructor */
function $h_Lmealorama_MeasuringUnit$() {
}
export { $h_Lmealorama_MeasuringUnit$ as $h_Lmealorama_MeasuringUnit$ };
$h_Lmealorama_MeasuringUnit$.prototype = $p;
$p.m = (function() {
  return "MeasuringUnit";
});
$p.aSm = (function(x$0) {
  return new $j_mealorama$002e$002dMeasuring$002dUnit.$c_Lmealorama_MeasuringUnit(x$0.g(0));
});
var $d_Lmealorama_MeasuringUnit$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MeasuringUnit$, "mealorama.MeasuringUnit$", ({
  GA: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_MeasuringUnit$ as $d_Lmealorama_MeasuringUnit$ };
var $n_Lmealorama_MeasuringUnit$;
function $m_Lmealorama_MeasuringUnit$() {
  if ((!$n_Lmealorama_MeasuringUnit$)) {
    $n_Lmealorama_MeasuringUnit$ = new $c_Lmealorama_MeasuringUnit$();
  }
  return $n_Lmealorama_MeasuringUnit$;
}
export { $m_Lmealorama_MeasuringUnit$ as $m_Lmealorama_MeasuringUnit$ };
//# sourceMappingURL=mealorama.-Measuring-Unit$.js.map
